import { Component, HostListener, OnInit, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AppComponent } from '../../app.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PaginationHelper } from '../../shared/services/pagination.service';
import { AccommodationService } from '../../features/accommodation/services/accommodation.service';
import { MonthsEnum } from '../../../assets/enum/monthsEnum';

@Component({
  selector: 'app-accommodation-monthly-rent',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    AgGridAngular,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
  ],
  templateUrl: './accommodation-monthly-rent.component.html',
  styleUrl: './accommodation-monthly-rent.component.scss',
})
export class AccommodationMonthlyRentComponent implements OnInit {
  public viewPortSize: boolean = false;
  public rowData: any[] | null = null;
  public loading: boolean = true;
  public error: any = null;
  private searchSubject = new Subject<string>();
  readonly dialog = inject(MatDialog);
  startDate: any;
  endDate: any;
  monthForm: FormGroup;
  months = Object.values(MonthsEnum);
  accommodationId: any;
  propertyName: any;
  totalAmount: any;

  columnDefs: (
    | {
        headerName: string;
        field: string;
        flex: number;
        valueFormatter?: undefined;
        cellRenderer?: undefined;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        headerName: string;
        field: string;
        flex: number;
        valueFormatter: (params: any) => string;
        cellRenderer?: undefined;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        field: string;
        headerName: string;
        flex: number;
        cellRenderer: (params: any) => HTMLDivElement;
        floatingFilter: boolean;
        filter: boolean;
        valueFormatter?: undefined;
      }
  )[];
  page = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 20, 50, 100];
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {
    this.columnDefs = [
      {
        headerName: 'Employee Name',
        field: 'employeeName',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Monthly Rent',
        field: 'monthlyRent',
        flex: this.viewPortSize ? 1 : 0,
      },
    ];
  }
  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public themeClass: string = 'ag-theme-quartz';

  constructor(
    private router: Router,
    private accommodationService: AccommodationService,
    private datePipe: DatePipe,
    private appComponent: AppComponent,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {}

  currentMonth = new Date().getMonth() + 1;

  ngOnInit(): void {
    this.monthForm = this.fb.group({
      month: [this.currentMonth],
    });

    this.route.queryParamMap.subscribe((queryParams) => {
      this.accommodationId = queryParams.get('accommodationId');
      this.monthlyRentSummary();
      console.log('Hii');
    });

    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.monthlyRentSummary(searchTerm);
      });

    this.checkViewportSize();

    this.appComponent.toggleSidebar();

    this.monthForm.get('month')?.valueChanges.subscribe((newMonth) => {
      this.currentMonth = newMonth;
      this.monthlyRentSummary();
    });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.pageSize = 10;
    this.page = 0;
    this.searchSubject.next(searchTerm);
  }

  monthlyRentSummary(search: string = '') {
    this.loading = true;

    const employeeName = search;
    const currentYear = new Date().getFullYear();
    const month = this.currentMonth;
    const propertyId = this.accommodationId;

    this.accommodationService
      .monthlyRentSummary(
        Number(currentYear),
        Number(month),
        Number(propertyId),
        employeeName
      )
      .subscribe({
        next: (data) => {
          this.propertyName = data?.monthlyRentSummary[0]?.propertyName;
          this.totalAmount = data?.totalRent
          this.rowData = data?.monthlyRentSummary.map((rent: any) => {
            return {
              id: rent?.id,
              employeeName: rent?.employeeName || '--',
              monthlyRent:
                rent?.monthlyRent != null
                  ? `AED ${Number(rent.monthlyRent).toFixed(2)}`
                  : '--',
            };
          });
          this.loading = false;
        },
        error: (err) => {
          console.error('Error fetching summary:', err);
          this.loading = false;
        },
      });
  }

  isDropdownOpen = false;

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}
